"use client";

import React from "react";
import { ScatterChart, Scatter, XAxis, YAxis, ResponsiveContainer, ReferenceArea, Cell } from "recharts";

const XIcon = ({ cx, cy, fill, shape }: any) => {
  if (cx === undefined || cy === undefined || shape === undefined) return null;

  const [d, rotate] = (() => {
    if (shape === "circle") return ["M10 2 A8 8 0 1 0 10 18 A8 8 0 1 0 10 2", 0];
    else if (shape === "square") return ["M 10 10 L 90 10 L 90 90 L 10 90 Z", 0];
    else return ["M10 3 L20 18 L0 18 Z", shape];
  })();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x={cx - 10}
      y={cy - 10}
      width={20}
      height={20}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
    >
      <path d={d} stroke="black" strokeWidth="1" transform={`rotate(${rotate} 10 10)`} fill={fill} />
    </svg>
  );
};

type LocationScatterChartProps = {
  data: {
    x: number;
    y: number;
    color: string;
    shape: string;
    count?: number;
  }[];
};

export default function LocationScatterChart({ data }: LocationScatterChartProps) {
  return (
    <ResponsiveContainer width={"100%"} height={"100%"}>
      <ScatterChart>
        <XAxis type="number" dataKey="x" name="x" domain={[0, 135]} hide />
        <YAxis type="number" dataKey="y" name="y" domain={[-10, 175]} reversed={true} hide />
        <ReferenceArea x1={52} x2={84} y1={28} y2={148} stroke="red" />
        <ReferenceArea x1={20} x2={116} y1={68} y2={108} stroke="red" />
        <ReferenceArea x1={20} x2={116} y1={28} y2={148} stroke="red" />
        <Scatter data={data} shape={<XIcon />}>
          {data.map((m, i) => (
            <Cell key={`cell-${i}`} fill={m.color} />
          ))}
        </Scatter>
      </ScatterChart>
    </ResponsiveContainer>
  );
}
